// @flow

import React from 'react';

import { ModalManager } from 'react-dynamic-modal';
import _ from "underscore";

import T from './T';
import Tlabel from './Tlabel';
import Tbutton from './Tbutton';
import Tfile from './Tfile';
import Tvalue from './Tvalue';
import Tinput from './Tinput';
import Tradio from './Tradio';
import Tcheckbox from './Tcheckbox';
import GlassImage from './GlassImage';

import ProductActions from '../actions/ProductActions';
import NotificationActions from '../actions/NotificationActions';
import ProductStore from '../stores/ProductStore';
import SettingsStore from '../stores/SettingsStore';
import NotificationModal from './NotificationModal';

import SchemaActions from "../actions/SchemaActions";
import SchemaStore from "../stores/SchemaStore";

import t from '../trans';
import type ProductInfo from "../ProductInfo";
import type {SchemaStoreState} from "../stores/SchemaStore";
import type {IntegerType} from "../model";
import Tselect from "./Tselect";


type Props = {
};


class Product extends React.Component<Props, ProductInfo> {

	/**
	 *
	 * @param props
	 */
	constructor(props: Props) {
		super(props);

		this.state = ProductStore.getState();

		this.onChange = this.onChange.bind(this);
		this.onChangeSchema = this.onChangeSchema.bind(this);

		this.onValueChanged = this.onValueChanged.bind(this);
		this.onClickOpenNcp = this.onClickOpenNcp.bind(this);
		this.onClickOpenGr2 = this.onClickOpenGr2.bind(this);
		this.onClickCalcPoints = this.onClickCalcPoints.bind(this);
		this.onClickReadProduct = this.onClickReadProduct.bind(this);
		this.onClickSaveProduct = this.onClickSaveProduct.bind(this);
		this.onClickDeleteProduct = this.onClickDeleteProduct.bind(this);
		this.onClickPrint = this.onClickPrint.bind(this);
		this.onClickMirror = this.onClickMirror.bind(this);
		this.onClickRotate90 = this.onClickRotate90.bind(this);
		this.onClickRotate = this.onClickRotate.bind(this);
		this.onClickMirrorShape = this.onClickMirrorShape.bind(this);
		this.onClickRadio = this.onClickRadio.bind(this);
		this.onClickMoveE = this.onClickMoveE.bind(this);
		this.onClickMoveP = this.onClickMoveP.bind(this);
        this.onClickMoveHud = this.onClickMoveHud.bind(this);
	}

	componentDidMount(): void {
		ProductStore.listen(this.onChange);
		SchemaStore.listen(this.onChangeSchema);

		SchemaActions.fetchSchema("product");
	}

	componentWillUnmount(): void {
		ProductStore.unlisten(this.onChange);
		SchemaStore.unlisten(this.onChangeSchema);
	}

	onChange(state: ProductInfo): void {
		this.setState(state);
	}

	onChangeSchema(state: SchemaStoreState): void {
		if (state.schemas.product != null) {
			ProductActions.setSchema.defer(state.schemas.product);
		}
	}

	onValueChanged(param: string | [string, string], value: string): void {
		// let newState = {};
		if (Array.isArray(param)) {
			// Massiivi elemendi väärtustamine:
			let field = param[0];	// Massiivi nimi
			let idx = param[1];		// Massiivi elemendi indeks
			ProductActions.changeValue(field, value, idx);
		} else {
			// Lihtelemendi väärtustamine:
			ProductActions.changeValue(param, value);
		}
	}

	askConfirmation(message: string, func: () => void): void {
        ModalManager.open(<NotificationModal title={t("Confirmation")} onClickOk={function() {
            func();
            ModalManager.close();
        }} okText={t('OK')} cancelText={t('Cancel')}>{message}</NotificationModal>);
    }

	/**
	 * Command12 (Call avafaildialoog(1))
	 */
	onClickOpenNcp(param: string, fileData: string, fileName: string, fileType: string): void {
		ProductActions.uploadNcpFile(fileName, fileData, fileType);
	}

	/**
	 * Command14
	 */
	onClickOpenGr2(param: string, fileData: string, fileName: string): void {
		ProductActions.uploadGrFile(fileName, fileData);
	}

	onClickCalcPoints(): void {
		ProductActions.calcPoints();
	}

	/**
	 * Tooteinfo lugemine serverist
	 */
	onClickReadProduct(): void {
		// Veendume, et toote number on antud:
		if (!this.state.kood) {
			NotificationActions.error(t("Please enter product index!"));
			return;
		}

		ProductActions.readProductData.defer(this.state.kood, null);
		//ProductActions.readProductData.defer(this.state.kood, "ncp");
		//ProductActions.readProductData.defer(this.state.kood, "dat");
	}

	/**
	 * Tooteinfo salvestamine serverisse
	 */
	onClickSaveProduct(): void {
		// Veendume, et toote number on antud:
		if (!this.state.kood) {
			NotificationActions.error(t("Please enter product index!"));
			return;
		}

        this.askConfirmation(t("Save product?"), function() {
            ProductActions.saveProductData(this.state.kood);
        }.bind(this));
	}

	/**
	 * Tooteinfo kustutamine serverist
	 */
	onClickDeleteProduct(): void {
		// Veendume, et toote number on antud:
		if (!this.state.kood) {
			NotificationActions.error(t("Please enter product index!"));
			return;
		}

		this.askConfirmation(t("Delete product?"), function() {
            ProductActions.deleteProduct(this.state.kood);
        }.bind(this));
	}

	/**
	 * Command13
	 */
	onClickPrint(): void {
	}

	/**
	 * Command7
	 */
	onClickMirror(): void {
		// Command7
		ProductActions.mirror();
	}

	/**
	 * Command9
	 */
	onClickMirrorShape(): void {
		// Command9
		ProductActions.mirrorShape();
	}

	onClickRotate90(): void {
		ProductActions.rotate90();
	}

	onClickRotate(): void {
		ProductActions.rotate();
	}

	onClickRadio(field: string, value: string): void {
		ProductActions.changeValue(field, value);
	}

	/**
	 * Command1 - <<
	 * Command2 - <
	 * Command3 - >
	 * Command4 - >>
	 * @param {number} direction Direction: 1 - big step left, 2 - left, 3 - right, 4 - big step right
	 */
	onClickMoveE(direction: number): void {
		ProductActions.moveE(direction);
	}

	/**
	 * Command5 - up
	 * Command6 - down
	 * @param {number} direction 1 - up, 2 - down
	 */
	onClickMoveP(direction: number): void {
		ProductActions.moveP(direction);
	}

    /**
     * Command5 - up
     * Command6 - down
     * @param {number} direction 1 - up, 2 - down
     */
    onClickMoveHud(direction: number): void {
        ProductActions.moveHud(direction);
    }

    onClickRemoveP(): void {
		ProductActions.removeP();
	}

    onClickAssignP(): void {
		ProductActions.assignP();
	}

	getNcpFileTypes(): Array<string> {
		let types = SettingsStore.getGlassFileType();
		return _.map(types.split(","), function (v) {
			return v.trim();
		});
	}

	renderEpointRadioGroup(): Array<React$Node> {
		let points1 = [];
		let points2 = [];
		for (let i = 0; i < this.state.lineCount*2; i++) {
			// Paigutame vaheldumisi üles ja alla:
			let p = (i % 2 ? points2 : points1);
			p.push(
				(<Tradio inline={true} name="epoint"
					checked={this.state.valitud_e == i}
					onClick={this.onClickRadio}
					onClickParam="valitud_e"
					value={i}
					key={'epoint_radio_'+i}
					>{'E'+(i+1).toString()}</Tradio>)
			);
		}
		return [(<div className="row" key="epoint_radio_g1"><div className="col-md-12 text-center">{points1}</div></div>),
		          (<div className="row" key="epoint_radio_g2"><div className="col-md-12 text-center">{points2}</div></div>)];
	}

	getPointCount(): IntegerType {
		return this.state.lineCount*3 + this.state.addPoints;
	}

	getBasePointCount(): IntegerType {
		return this.state.lineCount*3;
	}

    renderPpointRadioGroup(): React$Node {
		let points1 = [];
		let points2 = [];
		let pointsm = [];
		let pointsp = [];

		//let centerLineLastPoint = 3*Math.floor(this.state.lineCount/2 + 1) - 1;
		this.processPointsInOrder(function (i, line) {
			let p = null;
			if (i < this.state.lineCount*3) {
				if (i % 3 == 0) p = points1;
				else if (i % 3 == 2) p = points2;
				else if (i % 3 == 1) p = pointsm;
			} else {
				p = pointsp;
			}
			if (p != null) {
				p.push(
					<Tradio inline={true} name="ppoint"
							checked={this.state.valitud_p == i}
							onClick={this.onClickRadio}
							onClickParam='valitud_p'
							value={i}
							key={'ppoint_radio_'+i}
					>{this.state.pNimi[i]}</Tradio>
				);
			}
		}.bind(this));

		let noLeft = {paddingLeft: '0px'};
		return (
			<div className="row valign-parent" key="ppoint_radio_g1">
				<div className="col-md-2 text-center">
					<Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickMoveP} onClickParam={+10}><i className="fa fa-angle-double-up" aria-hidden="true"/></Tbutton>
					<Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickMoveP} onClickParam={+1}><i className="fa fa-angle-up" aria-hidden="true"/></Tbutton>
					<Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickMoveP} onClickParam={-1}><i className="fa fa-angle-down" aria-hidden="true"/></Tbutton>
					<Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickMoveP} onClickParam={-10}><i className="fa fa-angle-double-down" aria-hidden="true"/></Tbutton>
					{
						/*
						this.state.valitud_p >= this.state.lineCount*3 ?
                        	<Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickRemoveP} onClickParam={null}>{this.state.pOlemas[this.state.valitud_p] ? "-" : "+"}</Tbutton>
							: (this.state.valitud_p == centerLineLastPoint && this.state.addPoints > 0 ?
                            	<Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickAssignP} onClickParam={null}>{"="}</Tbutton>
								: null)
								*/
						null
					}
				</div>
				<div className="col-md-10 text-center valign-middle" style={noLeft}>
					<div>{points1}</div>
                    {this.state.lineCount == 3 ? (<div>{pointsm}</div>) : ''}
					<div>{points2}</div>
					<div>{pointsp}</div>
				</div>
			</div>
		);
	}

    renderHudRadioGroup(): React$Node {
        let points = [];

        //let centerLineLastPoint = 3*Math.floor(this.state.lineCount/2 + 1) - 1;
        for (let i = 0; i < this.state.hudPoints; i++) {
            points.push(
                <tr key={'ppoint_y_'+i}>
                    <td width="40px" align="center">
                        <Tradio inline={true} name="hudpoint"
                                checked={this.state.valitud_hud == i}
                                onClick={this.onClickRadio}
                                onClickParam='valitud_hud'
                                value={i}
                                key={'hudpoint_radio_'+i}
                        >{"H" + (i+1)}</Tradio>
                    </td>
                    <td align="center"><Tvalue width="50px" valueType="number" valueDecimals='1' value={this.state.hudv[i]} /></td>
                    <td align="center"><Tinput width="50px" valueType="number" valueDecimals='1' value={this.state.hudKorrektsioon[i]} onChange={this.onValueChanged} onChangeParam={['hudKorrektsioon',i]}/></td>
                </tr>
            );
        }

        let noLeft = {paddingLeft: '0px'};
        return [
            <div className="row" key="hudpoint_radio_g0">
                <Tlabel className="col-sm-4" style={{textAlign: "right"}}>Line no</Tlabel>
                <Tinput className="smallinput col-sm-8" width='40px' valueType="integer" value={this.state.hudLine} onChange={this.onValueChanged} onChangeParam='hudLine'/>
            </div>,
            <div className="row valign-parent align-items-center" key="hudpoint_radio_g1">
                <div className="col-md-2 text-center">
                    <Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickMoveHud} onClickParam={+10}><i className="fa fa-angle-double-up" aria-hidden="true"/></Tbutton>
                    <Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickMoveHud} onClickParam={+1}><i className="fa fa-angle-up" aria-hidden="true"/></Tbutton>
                    <Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickMoveHud} onClickParam={-1}><i className="fa fa-angle-down" aria-hidden="true"/></Tbutton>
                    <Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickMoveHud} onClickParam={-10}><i className="fa fa-angle-double-down" aria-hidden="true"/></Tbutton>
                </div>
                <div className="col-md-10 text-center valign-middle" style={noLeft}>
                    <table style={{margin: "auto"}}>
                        <tbody>
                        <tr className="gridtablehead">
                            <td></td>
                            <th><T>Y</T></th>
                            <th><T>Correction</T></th>
                        </tr>
                        {points}
                        </tbody>
                    </table>
                </div>
            </div>
        ];
    }

    renderPpointY(): React$Node {
		let p = [];

		this.processPointsInOrder(function (i, line) {
			if (!this.state.pOlemas[i]) return;

			p.push(
				<tr key={'ppoint_y_'+i}>
					<td width="40px" align="center">{this.state.pNimi[i]}</td>
					<td align="center"><Tvalue width="50px" valueType="number" valueDecimals='1' value={this.state.pv[i]} /></td>
					<td align="center"><Tinput width="50px" valueType="number" valueDecimals='1' value={this.state.pKorrektsioon[i]} onChange={this.onValueChanged} onChangeParam={['pKorrektsioon',i]}/></td>
				</tr>
			);
		}.bind(this));

		return (
			<table style={{margin: "auto"}}>
				<tbody>
				<tr className="gridtablehead">
					<td></td>
					<th><T>Y</T></th>
					<th><T>Correction</T></th>
				</tr>
				{p}
				</tbody>
			</table>
		);
	}

	renderEpoints(): React$Node {
		let p = [];
		for (let i = 0; i < this.state.lineCount * 2; i++) {
			// 1 -> 40px, 2 -> 50px
			let tdList = [
				(<td key="epoint_i1" align="center">{'E' + (i + 1).toString()}</td>),
				(<td key="epoint_i2" align="center"><Tvalue width="50px" valueType="number" valueDecimals='1' value={this.state.ex[i]+this.state.xnihe} /></td>),
			    (<td key="epoint_i3" align="center"><Tvalue width="50px" valueType="number" valueDecimals='1' value={this.state.ey[i]+this.state.ynihe} /></td>),
			    (<td key="epoint_i4" align="center"><Tinput width="50px" valueType="number" valueDecimals='1' value={this.state.ez[i]} onChange={this.onValueChanged} onChangeParam={['ez', i]}/></td>),
			    (<td key="epoint_i5" align="center"><Tinput width="50px" valueType="number" valueDecimals='1' value={this.state.eKalleA[i]} onChange={this.onValueChanged} onChangeParam={['eKalleA', i]}/></td>),
			    (<td key="epoint_i6" align="center"><Tinput width="50px" valueType="number" valueDecimals='1' value={this.state.eKalleB[i]} onChange={this.onValueChanged} onChangeParam={['eKalleB', i]}/></td>)
			];
			if (i % 2 == 0) tdList.push(<td key="epoint_i7" width="50px" align="center"> <Tvalue width="50px" valueType="integer" value={this.state.pikkus[i/2]} /> </td>);
			else tdList.push(<td key="epoint_i7" width="50px" align="center"></td>);
			tdList.push(<td key="epoint_i8"><Tinput width="50px" valueType="number" valueDecimals='1' value={this.state.s[i]} onChange={this.onValueChanged} onChangeParam={['s', i]}/></td>);
			p.push(<tr key={'epoint_'+i}>{tdList}</tr>);
		}
		return (
			<table style={{margin: "auto"}}>
				<tbody>
					<tr className="gridtablehead">
						<td width="55px"></td>
						<th width="55px">X</th>
						<th width="55px">Y</th>
						<th width="55px">Z</th>
						<th width="55px">A</th>
						<th width="55px">B</th>
						<th width="55px"><T>Length</T></th>
						<th width="55px"><T>Print2</T></th>
					</tr>
					{p}
					<tr style={{height: "10px"}}><td colSpan="8"></td></tr>
					<tr>
						<td colSpan="3" align="right"><Tlabel>Glass thickness:</Tlabel></td>
						<td colSpan="5"><Tinput width='50px' valueType="number" valueDecimals='1'
												value={this.state.klaasiPaksus}
												onChange={this.onValueChanged}
												onChangeParam='klaasiPaksus'/></td>
					</tr>
				</tbody>
			</table>
		);
	}

	renderAdasPrintPanel(): React$Node {
		if (this.state.adasAreasCount <= 0) return null;
		return (
			<div className="col-md-12">
				<div className="panel panel-default">
					<div className="panel-heading" style={{padding: '1px 15px'}}>
						<T>ADAS Print</T>
					</div>
					<div className="panel-body panel-body-sm">
						{this.renderAdasPrint()}
					</div>
				</div>
			</div>
		);
	}

	renderAdasPrint(): React$Node {
		let p = [];
		for (let i = 0; i < this.state.adasAreasCount; i++) {
			let tdList = [
				(<td key="apoint_i1" width="20%" align="center">{(i + 1).toString()}</td>),
				(<td key="apoint_i4" align="center"><Tinput width="50px" valueType="number" valueDecimals='1'
															value={this.state.adasarea_distance[i]}
															onChange={this.onValueChanged}
															onChangeParam={['adasarea_distance', i]}/></td>),
				(<td key="apoint_i6" align="center"><Tselect width="80px"
															 value={this.state.adasarea_type[i]}
															 onChange={this.onValueChanged}
															 onChangeParam={['adasarea_type', i]}
															 options={[["0", t("Glass")],["1", t("Print2")]]}/></td>)
			];
			p.push(<tr key={'epoint_'+i}>{tdList}</tr>);
		}
		return (
			<table style={{margin: "auto"}}>
				<tbody>
				<tr className="gridtablehead">
					<th><T>Point</T></th>
					<th width="100px"><T>Distance from the edge</T></th>
					<th><T>Type</T></th>
				</tr>
				{p}
				</tbody>
			</table>
		);

	}

	/**
	 * @param {function} func Function in form: func(pointIndex, lineIndex)
	 */
	processPointsInOrder(func: (IntegerType, IntegerType) => void): void {
		let basePointCount = this.getBasePointCount();
		for (let i = 0; i < basePointCount; i++) {
			func(i, this.state.pJoon[i]);
		}
		for (let j = this.state.addPoints - 1; j >= 0; j--) {
			func(basePointCount+j, this.state.pJoon[basePointCount+j]);
		}
	}

	renderPpointsRowHead(): Array<React$Node> {
		let p = [];
		this.processPointsInOrder(function (i) {
			if (!this.state.pOlemas[i]) return;
			p.push(<th key={'ppoint_h_'+i}>{this.state.pNimi[i]}</th>);
		}.bind(this));
		let pointCount = this.getPointCount();
		p.push(<th key={'ppoint_h_'+pointCount}>{t("ANGLE")}</th>);
		return p;
	}

    renderPpointsRow(field: string): Array<React$Node> {
		let p = [];
		this.processPointsInOrder(function (i) {
			if (!this.state.pOlemas[i]) return;
			p.push(<td key={'ppoint_i'+i} className="tolerancecell"><Tinput width="40px" valueDecimals='1' valueType={"number"} value={this.state[field][i]} onChange={this.onValueChanged} onChangeParam={[field, i]}/></td>);
		}.bind(this));
        let pointCount = this.getPointCount();
		p.push(
			<td
				key={'ppoint_i'+pointCount}
				className="tolerancecell">
				<Tinput
					width="40px"
					valueDecimals='1'
					valueType={"number"}
					value={this.state.angle[field]}
					onChange={this.onValueChanged}
					onChangeParam={["angle", field]}/>
			</td>);
		return p;
	}

    renderHudRowHead(): Array<React$Node> {
        let p = [];
        for (let i = 0; i < this.state.hudPoints; i++) {
            p.push(<th key={'hud_h_'+i}>{"H" + (i+1)}</th>);
        }
        return p;
    }

    renderHudRow(field: string): Array<React$Node> {
        let p = [];
        for (let i = 0; i < this.state.hudPoints; i++) {
            p.push(
                <td key={'hud_i'+i} className="tolerancecell">
                    <Tinput width="40px" valueDecimals='1' valueType={"number"} value={this.state[field][i]}
                            onChange={this.onValueChanged} onChangeParam={[field, i]}/>
                </td>
            );
        }
        return p;
    }

    renderAdasButtons(): Array<React$Node> {
		let p = [];
		let centerLine = (this.state.lineCount - 1) / 2;
		let skip = 0;
		let isFirst = true;
		let order = 0;
		this.processPointsInOrder(function (i, line) {
			if (line == centerLine) {
				if (order++ > 1) {
					// Center line
					if (isFirst) {
						p.push(
							<td key="adas_title" colSpan={skip} align="right">{t("ADAS window point")+":"}</td>
						);
						isFirst = false;
						skip = 0;
					}
					p.push(
						<td key={"adas_"+i} align="center">
							<Tradio name="adas"
									checked={this.state.adas === i}
									onClick={this.onClickRadio}
									onClickParam="adas"
									value={i}
									key={'adas_radio_'+i}
							/>
						</td>
					);
				} else {
					if (isFirst) skip++;
				}
			}
			else {
				if (isFirst) skip++;
				else {
					p.push(<td key={"adas_"+i}></td>);
				}
			}
		}.bind(this));
		p.push(<td key={"adas_"+this.state.pJoon.length}></td>);
		return p;
	}

	renderAngleButtons(): Array<React$Node> {
		let p = [];
		let centerLine = (this.state.lineCount - 1) / 2;
		let skip = 0;
		let isFirst = true;
		let order = 0;
		this.processPointsInOrder(function (i, line) {
			if (line == centerLine) {
				if (order++ > 1) {
					// Center line
					if (isFirst) {
						p.push(
							<td key="angle_title" colSpan={skip} align="right">{t("Points used for ANGLE calculation")+":"}</td>
						);
						isFirst = false;
						skip = 0;
					}
					p.push(
						<td key={"angle_"+i} align="center">
							<Tcheckbox name="anglePoints"
									   checked={this.state.anglePoints[i]}
									   onClick={this.onValueChanged}
									   onClickParam={['anglePoints', i]}
									   value={true} />
						</td>
					);
				} else {
					if (isFirst) skip++;
				}
			}
			else {
				if (isFirst) skip++;
				else {
					p.push(<td key={"angle_"+i}></td>);
				}
			}
		}.bind(this));
		p.push(<td key={"angle_"+this.state.pJoon.length}><Tvalue valueType="integer" value={this.state.angleValue}/></td>);
		return p;
	}

	getPpointNamesCenter(): string {
		let names = [];
		let basePointCount = this.getBasePointCount();
		for (let i = 0; i < basePointCount; i++) {
			if (i % 3 == 1) names.push((i+1).toString());
		}
		return 'P ' + names.join(', ');		// P 2, 5, 8, 11, 14
	}

	getPpointNamesEdge(): string {
		let names = [];
		let basePointCount = this.getBasePointCount();
		for (let i = 0; i < basePointCount; i++) {
			if (i % 3 == 0 || i % 3 == 2) names.push((i+1).toString());
		}
		return 'P ' + names.join(', ');		// P 1, 3, 4, 6, 7, 9, 10, 12, 13, 15
	}

	renderTolerances(type: 'k' | 's', tolerants1: IntegerType, tolerants2: IntegerType): React$Node {
		return (
			<div className="form-horizontal form-horizontal-sm text-center">
				<div className="form-group tolerance1">
					<Tlabel>Tolerance 1:</Tlabel>
					<Tinput width='40px'
							valueType="number"
							valueDecimals='1'
							value={tolerants1}
							onChange={this.onValueChanged}
							onChangeParam={'tolerants1' + type}/>
				</div>
				<div className="form-group tolerance2">
					<Tlabel>Tolerance 2:</Tlabel>
					<Tinput width='40px'
							valueType="number"
							valueDecimals='1'
							value={tolerants2}
							onChange={this.onValueChanged}
							onChangeParam={'tolerants2' + type}/>
				</div>
			</div>
		);
	}

	renderProductButtons(): React$Node {
		return (
			<div className="form-inline">
				<div className="form-group">
					<Tlabel>Code:</Tlabel>
					<Tinput width='80px' value={this.state.kood} onChange={this.onValueChanged}
							onChangeParam='kood'/>
				</div>
				<span>{" "}</span>
				<Tbutton width='100px' onClick={this.onClickReadProduct}>Read product</Tbutton>
				<Tbutton width='100px' onClick={this.onClickSaveProduct}>Save product</Tbutton>
				<Tbutton width='100px' onClick={this.onClickDeleteProduct}>Delete product</Tbutton>
				<div className="form-group">
					<Tlabel>Model name:</Tlabel>
					<Tinput width='250px' value={this.state.mudeliNimi}
							onChange={this.onValueChanged} onChangeParam='mudeliNimi'/>
				</div>
				{
					SettingsStore.isSimpleUi() ? '' :
						(<div className="form-group">
							<Tlabel>SCAN:</Tlabel>
							<Tinput width='100px' value={this.state.scan}
									onChange={this.onValueChanged}
									onChangeParam='scan'/>
						</div>)
				}
			</div>
		);
	}

	renderButtonsGroup(): React$Node {
		return (
			<div className="row">
				<div className="col-md-5">
					<div role="group">
						{this.renderNcpUploadButtons()}
						<Tfile width='100px' as='text' accept='.gr2' onClick={this.onClickOpenGr2}>{t("Upload .%s", "GR2")}</Tfile>
					</div>
				</div>{/* col-md-6 */}

				<div className="col-md-7">
					<div role="group">
						<Tbutton width="120px" onClick={this.onClickRotate90}>Rotate 90°</Tbutton>
						<Tbutton width="120px" onClick={this.onClickRotate}>Rotate 180°</Tbutton>
						<Tbutton width="120px" onClick={this.onClickMirrorShape}>Mirror glass shape</Tbutton>
						<Tbutton width='120px' onClick={this.onClickMirror}>Mirror lines</Tbutton>
					</div>
				</div>{/* col-md-6 */}
			</div>
		);
	}

	renderNcpUploadButtons(): Array<React$Node> {
		let ncpFileTypes = this.getNcpFileTypes();
		let buttons = [];
		for (let type of ncpFileTypes) {
			buttons.push(
				<Tfile key={type} width='100px' as='text' accept={'.' + type}
					   onClick={(param, fileData, fileName) => this.onClickOpenNcp(param, fileData, fileName, type)}>{t("Upload .%s", type.toUpperCase())}</Tfile>
			);
		}
		return buttons;
	}

	render(): React$Node {
		return (
			<div>

				<div className="row">
					<div className="col-md-12">
						<div className="panel panel-default">
							<div className="panel-heading" style={{padding: '1px 15px'}}>
								<div className="row">
									<div
										className="col-md-4">{t("DAT/NCP file:") + " " + this.state.failiNimi + " "}</div>
									<div className="col-md-8"><T>GR2 file:</T>{" " + this.state.grFailiNimi + " "}</div>
								</div>
							</div>
							<div className="panel-body panel-body-sm form-inline">
								{this.renderProductButtons()}
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md-3">
						<div className="panel panel-default">
							<div className="panel-body panel-body-sm">
								{this.renderButtonsGroup()}
							</div>
						</div>

						<div className="row">
							<div className="col-md-12">
								<div className="panel panel-default">
									<div className="panel-heading" style={{padding:'1px 15px'}}><T>Center</T></div>
									<div className="panel-body panel-body-sm form-horizontal form-horizontal-sm">
										<div className="form-group"><Tlabel className="col-sm-6" style={{textAlign: "right"}}>X-move:</Tlabel><Tinput className="smallinput col-sm-6" width='40px' valueType="integer" value={this.state.xnihe} onChange={this.onValueChanged} onChangeParam='xnihe'/></div>
										<div className="form-group"><Tlabel className="col-sm-6" style={{textAlign: "right"}}>Y-move:</Tlabel><Tinput className="smallinput col-sm-6" width='40px' valueType="integer" value={this.state.ynihe} onChange={this.onValueChanged} onChangeParam='ynihe'/></div>
										{
											SettingsStore.isSimpleUi() ?
												'' :
												(<div className="form-group"><Tlabel className="col-sm-6" style={{textAlign: "right"}}>Distance:</Tlabel><Tinput className="smallinput col-sm-6" width='40px' valueType="integer" value={this.state.distants} onChange={this.onValueChanged} onChangeParam='distants'/></div>)
										}
									</div>
								</div>{/* panel */}
							</div>
						</div>

						<div className="row">
							<div className="col-md-12">
								<div className="panel panel-default">
									<div className="panel-heading" style={{padding:'1px 15px'}}><T>Move E-point</T></div>
									<div className="panel-body panel-body-sm">
										{this.renderEpointRadioGroup()}
										<p/>
										<div className="row"><div className="col-md-12 text-center">
											<Tbutton width='50px' className="btn btn-default btn-xs" onClick={this.onClickMoveE} onClickParam={-10}><i className="fa fa-angle-double-left" aria-hidden="true"/></Tbutton>
											<Tbutton width='50px' className="btn btn-default btn-xs" onClick={this.onClickMoveE} onClickParam={-1}><i className="fa fa-angle-left" aria-hidden="true"/></Tbutton>
											<Tbutton width='50px' className="btn btn-default btn-xs" onClick={this.onClickMoveE} onClickParam={+1}><i className="fa fa-angle-right" aria-hidden="true"/></Tbutton>
											<Tbutton width='50px' className="btn btn-default btn-xs" onClick={this.onClickMoveE} onClickParam={+10}><i className="fa fa-angle-double-right" aria-hidden="true"/></Tbutton>
										</div></div>
									</div>
								</div>{/* panel */}
							</div>
						</div>{/* row */}

						<div className="row">
							<div className="col-md-12">
								<div className="panel panel-default">
									<div className="panel-heading" style={{padding:'1px 15px'}}><T>Move P-point</T></div>
									<div className="panel-body panel-body-sm">
										{this.renderPpointRadioGroup()}
									</div>
								</div>{/* panel */}
							</div>
						</div>{/* row */}

                        {
                            SettingsStore.getHudPoints() == 0 ? '' :
                                (<div className="row">
                                    <div className="col-md-12">
                                        <div className="panel panel-default">
                                            <div className="panel-heading" style={{padding:'1px 15px'}}>
                                                <T>HUD points</T>
                                            </div>
                                            <div className="panel-body panel-body-sm">
                                                {this.renderHudRadioGroup()}
                                            </div>
                                        </div>
                                    </div>
                                </div>)
                        }

						<div className="row">
							<div className="col-md-12">
								<div className="panel panel-default">
									<div className="panel-heading" style={{padding: '1px 15px'}}>
										<T>P-points</T>
									</div>
									<div className="panel-body panel-body-sm">
										{this.renderPpointY()}
									</div>
								</div>
								{/* panel */}
							</div>
							{/* col-md-3 */}
						</div>

						<div className="row">
							<div className="col-md-12">
								<div className="panel panel-default">
									<div className="panel-heading" style={{padding:'1px 15px'}}>{this.getPpointNamesCenter()}</div>
									<div className="panel-body panel-body-sm">
										{this.renderTolerances("k", this.state.tolerants1k, this.state.tolerants2k)}
									</div>
								</div>{/* panel */}
							</div>{/* col-md-12 */}
						</div>

						<div className="row">
							<div className="col-md-12">
								<div className="panel panel-default">
									<div className="panel-heading" style={{padding:'1px 15px'}}>{this.getPpointNamesEdge()}</div>
									<div className="panel-body panel-body-sm">
										{this.renderTolerances("s", this.state.tolerants1s, this.state.tolerants2s)}
									</div>
								</div>{/* panel */}
							</div>{/* col-md-12 */}
						</div>

					</div>{/* col-md-3 */}

					<div className="col-md-9">

						<div className="row">
							<div className="col-md-12">
								<div className="panel panel-default">
									<div className="panel-heading" style={{padding: '1px 15px'}}>
										<T>Image</T>
									</div>
									<div className="panel-body panel-body-sm">
										<GlassImage width={880} height={500} product={this.state}/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md-7">
								<div className="panel panel-default">
									<div className="panel-heading" style={{padding: '1px 15px'}}>
										<T>E-points</T>
									</div>
									<div className="panel-body panel-body-sm">
										{this.renderEpoints()}
									</div>
								</div>
								{/* panel */}
							</div>
							{/* col-md-7 */}
							<div className="col-md-5">
								<div className="row">{this.renderAdasPrintPanel()}</div>
								{
									SettingsStore.isRotatedMeasurementAllowed() ?
										(
											<div className="row">
												<div className="col-md-12">
													<div className="panel panel-default">
														<div className="panel-heading" style={{padding:'1px 15px'}}><T>Rotated measurement</T></div>
														<div className="panel-body panel-body-sm">
															<table>
																<tbody>
																<tr>
																	<td>
																		<Tcheckbox inline={true} name="rotatedFirstLine"
																				   checked={this.state.keeratud_esimene}
																				   onClick={this.onValueChanged}
																				   onClickParam='keeratud_esimene'
																				   value={true}>First line</Tcheckbox>
																	</td>
																</tr>
																<tr>
																	<td>
																		<Tcheckbox inline={true} name="rotatedLastLine"
																				   checked={this.state.keeratud_viimane}
																				   onClick={this.onValueChanged}
																				   onClickParam='keeratud_viimane'
																				   value={true}>Last line</Tcheckbox>
																	</td>
																</tr>
																</tbody>
															</table>
														</div>
													</div>{/* panel */}
												</div>
											</div>
										) : ""
								}
							</div>{/* col-md-5 */}
						</div>

						<div className="row">
							<div className="col-md-12">
								<div className="panel panel-default">
									<div className="panel-body panel-body-sm">
										<table width="100%">
											<tbody>
												<tr className="gridtablehead">
													{this.renderPpointsRowHead()}
												</tr>
												<tr className="tolerancerow tolerance2">
                                                    {this.renderPpointsRow('pYlemineTolerants2')}
												</tr>
												<tr className="tolerancerow tolerance1">
                                                    {this.renderPpointsRow('pYlemineTolerants1')}
												</tr>
												<tr className="tolerancerow">
													{this.renderPpointsRow('pNominaal')}
												</tr>
												<tr className="tolerancerow tolerance1">
                                                    {this.renderPpointsRow('pAlumineTolerants1')}
												</tr>
												<tr className="tolerancerow tolerance2">
                                                    {this.renderPpointsRow('pAlumineTolerants2')}
												</tr>
												<tr>
													{this.renderAdasButtons()}
												</tr>
												<tr>
													{this.renderAngleButtons()}
												</tr>
											</tbody>
										</table>
									</div>
								</div>{/* panel */}
							</div>{/* col-md-12 */}
						</div>

                        {
                            SettingsStore.getHudPoints() == 0 ? '' :
                                (
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="panel panel-default">
                                                <div className="panel-heading" style={{padding: '1px 15px'}}>
                                                    <T>HUD</T>
                                                </div>
                                                <div className="panel-body panel-body-sm">
                                                    <table width="100%">
                                                        <tbody>
                                                        <tr className="gridtablehead">
                                                            {this.renderHudRowHead()}
                                                        </tr>
                                                        <tr className="tolerancerow tolerance2">
                                                            {this.renderHudRow('hudYlemineTolerants2')}
                                                        </tr>
                                                        <tr className="tolerancerow tolerance1">
                                                            {this.renderHudRow('hudYlemineTolerants1')}
                                                        </tr>
                                                        <tr className="tolerancerow">
                                                            {this.renderHudRow('hudNominaal')}
                                                        </tr>
                                                        <tr className="tolerancerow tolerance1">
                                                            {this.renderHudRow('hudAlumineTolerants1')}
                                                        </tr>
                                                        <tr className="tolerancerow tolerance2">
                                                            {this.renderHudRow('hudAlumineTolerants2')}
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {/* panel */}
                                        </div>
                                        {/* col-md-7 */}
                                    </div>
                                )
                        }

                    </div>{/* col-md-9 */}
				</div>{/* row */}
			</div>
        );
	}
}

export default Product;
